const OAuthCallback = () => import('@/views/OAuthCallback')

export default [
	{
		component: OAuthCallback,
		name: 'oauth-callback',
		path: 'oauth/callback'
	}
]
